import React, {Fragment, Component} from "react";

import {Col, Row, Button, FormGroup, Label, Input} from 'reactstrap';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import BlockUi from "react-block-ui";
import Loader from "react-loaders";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { getURLParameters, checkUIBlock } from "../../../utils/service";
import { setResetPasswordAction, setResetTokenAction } from "../../../reducers/ui/passwordReset";
import { apiPasswordResetAction } from "../../../sagas/apiCallSaga";
import { API_LIST } from "../../../utils/api";
import { history } from "../../../utils/service";

const mapStateToProps = store => {
    return {
        state: store.ui.passwordReset,
        apiCallData: store.apiCallData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setResetToken: setResetTokenAction,
        setResetPassword: setResetPasswordAction,
        doResetPassword: apiPasswordResetAction,
    }, dispatch)
}

class PasswordReset extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        let { token } = getURLParameters( window.location.href)

        console.log(token)

        if ( undefined === token) {
            history.push( "/")
            return 
        }

        this.props.setResetToken( token)
    }

    onClickReset = () => {
        let { token, password } = this.props.state
        this.props.doResetPassword( token, password)
    }

    render() {

        let { apiCallData } = this.props

        return (
            <Fragment>
                <div className="h-100">
                    <ReactCSSTransitionGroup
                        component="div"
                        transitionName="TabsAnimation"
                        transitionAppear={true}
                        transitionAppearTimeout={0}
                        transitionEnter={false}
                        transitionLeave={false}>
                        <BlockUi tag="div" blocking={checkUIBlock(this.props.apiCallData[API_LIST.PASSWORD_RESET.ID])} className="block-overlay-dark"
                                loader={<Loader color="#ffffff" active type={"ball-spin-fade-loader"}/>}>
                            <Row className="h-100 no-gutters">                            
                                <Col md="12" className="h-100 d-flex bg-white justify-content-center align-items-center">
                                    <Col lg="4" md="6" sm="8" className="mx-auto app-login-box">
                                        <h4 className="mb-0">
                                            <div>Please reset your password...</div>
                                        </h4>
                                        <Row className="divider" />
                                        <div>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Input type="password" name="password" id="examplePassword" onChange={e => this.props.setResetPassword( e.target.value)}
                                                                placeholder="Password here..." value={this.props.state.password} required/>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="divider"/>
                                            <div className="d-flex align-items-center">
                                                <div className="ml-auto">
                                                    <Button color="primary" size="lg" onClick={this.onClickReset}>Reset Password</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Col>
                            </Row>
                        </BlockUi>
                    </ReactCSSTransitionGroup>
                </div>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset)